import { DateUtils } from '@wyz/utils';
import {
  IAdvert,
  IAdvertForm,
  IAdvertPayload,
  ICriteria,
} from '~/connect/types';

export function fromFormToPayload(
  data: IAdvertForm,
  criteria: ICriteria[],
): IAdvertPayload {
  return {
    ...data,
    startDate: data.startDate
      ? DateUtils.formatTimestamp(data.startDate, {
          customFormat: DateUtils.CUSTOM_DATE_FORMAT.DMY,
        })
      : null,
    endDate: data.endDate
      ? DateUtils.formatTimestamp(data.endDate, {
          customFormat: DateUtils.CUSTOM_DATE_FORMAT.DMY,
        })
      : null,
    criteria: data.criteria.map(({ criterion, values }) => ({
      criterion,
      values:
        criteria
          .find((criteria) => criteria.id === criterion.id)
          ?.values.filter((value) =>
            values.some((selectedValueId) => selectedValueId === value.id),
          ) ?? [],
    })),
    customerScope: data.customerScope.map((scope) => ({
      id: scope,
    })),
  };
}

export function toFormData(advert: IAdvert): IAdvertForm {
  return {
    ...advert,
    endDate: advert.endDate ? new Date(advert.endDate) : advert.endDate,
    startDate: advert.startDate ? new Date(advert.startDate) : advert.startDate,
    criteria: advert.criteria.map(({ criterion, values }) => ({
      criterion,
      values: values.map((value) => value.id),
    })),
    customerScope: advert.customerScope.map((scope) => scope.id),
  };
}
